import React from 'react';

function Footer() {
    return (
        <footer style={{ backgroundColor: '#fff', padding: '20px', textAlign: 'center', borderTop: '1px solid #eee' }}>
            <p>&copy; 2026 Aplikacja CRM Michał Nowotarski</p>
        </footer>
    );
}

export default Footer;